import { RootPaths } from '@/routes/paths';

export type EmailType = RootPaths.FORGOT_PASSWORD_EMAIL | RootPaths.FORGOT_USERNAME_EMAIL;

export const pathnameToEmailTitleTypeMap: Record<EmailType, string> = {
  [RootPaths.FORGOT_PASSWORD_EMAIL]: 'Email with temporary password was sent!',
  [RootPaths.FORGOT_USERNAME_EMAIL]: 'Email was sent!',
};

export const pathnameToEmailTextTypeMap: Record<EmailType, string> = {
  [RootPaths.FORGOT_PASSWORD_EMAIL]:
    'Email was successfully sent!  Please, check your email with temporary password and log in again!',
  [RootPaths.FORGOT_USERNAME_EMAIL]:
    'Email was successfully sent!  Please, check your email with new Username and log in again! ',
};
